export const INVOICE_LOGO_WRAPPER_HEIGHT = 150
